import routers, {ServerConfig, buildPath} from '@/config/routers';

import {genMsgId} from './utils';
import kuJSSDKEventBus, {DOC_PUBLISH, NEW_DOC_VERSION} from './bus';
import {addParamToCustomUrl} from '@/utils/kuQuery';
import KU_QUERY from '@/constants/common/searchParamKeys';

export function emit(eventName: string, data: any) {
    if (window.top === window.self) {
        return;
    }
    window.parent.postMessage({
        type: 'kujssdk-event-emit',
        id: genMsgId(),
        eventName,
        data,
    }, '*');
}

kuJSSDKEventBus.on(DOC_PUBLISH, (data) => {
    emit(DOC_PUBLISH, data);
});

kuJSSDKEventBus.on(NEW_DOC_VERSION, (data) => {
    const path = buildPath(routers.Knowledge.docEditionPath, {
        spaceGuid: data.spaceGuid,
        groupGuid: data.groupGuid,
        repositoryGuid: data.repositoryGuid,
        docGuid: data.docGuid,
    });
    const url = ServerConfig.origin + path;
    const urlObj = addParamToCustomUrl(url, KU_QUERY.document.editionId, data.editionId);
    data.editionUrl = urlObj.href;

    emit(NEW_DOC_VERSION, data);
});
